import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
import { TrendingUp, BookOpen, Map, Users, ArrowRight, Lightbulb, Target } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Solar Panel Cleaning",
  description: "Our signature pure water system removes stubborn dust and grime, restoring your panels to peak manufacturer-rated efficiency.",
  icon: Target,
  href: "/ServicesPage"
}, {
  title: "Residential Solar",
  description: "Safe, roof-friendly cleaning methods designed for home systems. We protect your investment while maximising your daily energy savings.",
  icon: Users,
  href: "/ServicesPage"
}, {
  title: "Commercial Systems",
  description: "Expert cleaning for large-scale commercial arrays. We provide scheduled maintenance that ensures your business gets the most efficiency possible.",
  icon: TrendingUp,
  href: "/ServicesPage"
}, {
  title: "Bird & Debris Removal",
  description: "Specialised removal of bird droppings and organic debris that cause hot-spots and permanent cell damage to your solar infrastructure.",
  icon: Map,
  href: "/ServicesPage"
}, {
  title: "Efficiency Optimization",
  description: "Advanced system analysis and cleaning protocols that can boost your total energy output by up to 30% in high-dust environments.",
  icon: BookOpen,
  href: "/ServicesPage"
}];
export default function StrategicServicesModules() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="4006" id="our-services" ref={ref} className="relative py-24 px-4 md:px-8 overflow-hidden bg-white text-[hsl(220,40%,20%)]">
      <div className="max-w-7xl mx-auto">
        <div className={`mb-16 text-center transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-5xl font-display font-bold text-[hsl(220,40%,20%)] mb-4 tracking-tight">
            Our Professional Services
          </h2>
          <p className="text-[hsl(220,20%,45%)] max-w-2xl mx-auto font-sans text-lg leading-relaxed">
            Maximize your energy output with our specialized cleaning and maintenance solutions, tailored for both residential and commercial solar systems.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, i) => <div key={i} data-index={i} className={`transition-all duration-700 delay-[${i * 100}ms] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <Card className="h-full bg-white/40 backdrop-blur-md border border-white/60 shadow-[0_8px_32px_rgba(35,50,20,0.06)] hover:shadow-[0_20px_40px_rgba(45,100,50,0.12)] hover:-translate-y-2 transition-all duration-500 group rounded-[24px] flex flex-col">
                <CardHeader className="pb-4">
                  <div className="mb-4 inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-[hsl(200,95%,95%)] border border-[hsl(200,95%,90%)] group-hover:border-[hsl(45,100%,50%)]/40 transition-colors shadow-sm">
                    <service.icon className="w-7 h-7 text-[hsl(45,100%,50%)] stroke-[2px]" aria-hidden="true" />
                  </div>
                  <CardTitle className="font-display font-bold text-xl text-[hsl(220,40%,20%)] group-hover:text-[hsl(45,100%,50%)] transition-colors">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex-grow">
                  <p className="font-sans text-[16px] leading-relaxed text-[hsl(220,20%,40%)]">
                    {service.description}
                  </p>
                </CardContent>
                <CardFooter className="pt-4">
                  <Link to={service.href} className="inline-flex items-center text-sm font-semibold text-[hsl(220,40%,20%)] hover:text-[hsl(45,100%,50%)] transition-colors group/link">
                    View Service Details
                    <ArrowRight className="ml-2 w-4 h-4 transition-transform duration-300 group-hover/link:translate-x-1" />
                  </Link>
                </CardFooter>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}